import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { goEnquire } from "../../lib/scroll";

export const ServiceCard = ({ service, wide = false }) => {
  const navigate = useNavigate();
  const Icon = service.icon;
  return (
    <article
      data-testid={`service-card-${service.slug}`}
      className={`glow-hover group relative flex h-full flex-col justify-between overflow-hidden rounded-xl border border-gray-200 bg-white p-8 shadow-[0_2px_10px_rgba(16,20,24,0.04)] ${wide ? "md:col-span-2" : ""}`}
    >
      <div className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full bg-gold/10 blur-3xl opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
      <div>
        <span className="flex h-12 w-12 items-center justify-center rounded-lg border border-gold-line bg-gold-tint text-gold-deep">
          <Icon size={22} strokeWidth={1.6} />
        </span>
        <h3 className="mt-6 font-heading text-xl font-semibold tracking-tight text-navy md:text-2xl">{service.title}</h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-gray-600">{service.short}</p>
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <button
          onClick={() => navigate(`/solutions/${service.slug}`)}
          data-testid={`know-more-${service.slug}`}
          className="flex items-center gap-1.5 rounded-full border border-gray-300 px-4 py-2 text-xs font-semibold text-gray-800 transition-colors duration-300 hover:border-orange hover:text-orange-deep"
        >
          Know More <ArrowRight size={13} />
        </button>
        <button
          onClick={() => goEnquire(navigate, service.title)}
          data-testid={`enquire-${service.slug}`}
          className="rounded-full bg-gold px-4 py-2 text-xs font-bold text-inkx transition-transform duration-300 hover:scale-105"
        >
          Enquire Now
        </button>
      </div>
    </article>
  );
};
